var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLendingJourney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5L12 6C12 7.10457 12.8954 8 14 8L15 8C16.1046 8 17 8.89543 17 10C17 11.1046 16.1046 12 15 12L9 12C7.89543 12 7 12.8954 7 14C7 15.1046 7.89543 16 9 16L10 16C11.1046 16 12 16.8954 12 18L12 19M2 6L2 18C2 20.2091 3.79086 22 6 22L18 22C20.2091 22 22 20.2091 22 18L22 6C22 3.79086 20.2091 2 18 2L6 2C3.79086 2 2 3.79086 2 6Z",
    stroke: "#231F20",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLendingJourney);
export default __webpack_public_path__ + "static/media/lending-journey.ea9cb7c39454c353003b7caf1043e34c.svg";
export { ForwardRef as ReactComponent };